import React from 'react';
import Radio from 'widgets/Radio/Radio';

import FormContext from './FormContext';

export default React.forwardRef((props, ref) => (
  <FormContext.Consumer>
    {formParams => (
      <Radio
        {...props}
        onValidate={formParams.onValidate}
        onChange={formParams.onChange}
        errorMessage={formParams.validationErrors[props.name]}
        registerField={formParams.registerField}
        shouldRunValidators={formParams.shouldRunValidators}
        value={formParams.formData[props.name] || ''}
        ref={ref}
      />
    )}
  </FormContext.Consumer>)
);
